const crud = { c: false, r: false, u: false, d: false };

export const tower360 = Object.freeze({
  configTower360: { ...crud },
});
